module.exports = __webpack_public_path__ + "static/img/2_1.d39d759d.jpg";